<div class="bg__login" style="background-image: url('{{bgLoginPath}}')">
  <div class="login__container">
    <div class="login-box">
      <form [formGroup]="form">
        <div nz-row [nzGutter]='[10,10]'>
          <div nz-col [nzXs]="24">
            <h2 style="font-weight: bold">
              {{ 'common.user.forgetPassword2' | translate }}
            </h2>
          </div>
          <!--Username-->
          <div nz-col *ngIf="isStep1" [nzXs]="24">
            <div class="input-title">
              <label class="label__icon"><i class="far fa-user"></i></label>
              <span>{{ 'common.user.accountName' | translate }}</span>
            </div>
            <hbt-input-text
              class="login-input"
              [defaultInput]="true"
              placeholderText="{{ 'common.user.accountName' | translate }}" formControlName="loginName"
              [type]="isSubmitted && f['loginName'].errors ? 'error' : 'default'"
              [showError]="isSubmitted && f['loginName'].errors !== null"
              [errors]="f['loginName'].errors"
              [errorDefs]="[{ errorName: 'required', errorDescription: 'common.validate.required' | translate: {'param': 'common.user.accountName' | translate }}]"></hbt-input-text>
          </div>

          <!--captcha-->
          <div nz-col class="captcha-group" style="justify-content: center; display: flex" *ngIf="isStep1" [nzXs]="24">
            <div id="recaptcha"></div>
          </div>

          <div *ngIf="!isStep1" nz-col [nzXs]="24" style="padding: -10px">
            <div *ngIf="sentOtpEmail" class="otp-sent-info">
              OTP đã được gửi về mail
              <strong>{{ sentOtpEmail }}</strong>
            </div>
          </div>

          <!--otp-->
          <div *ngIf="!isStep1" nz-col [nzXs]="24">
            <div style="display: flex;flex-direction: row; justify-content: space-between">
              <div class="input-titles">
                <label><i class="fas fa-shield"></i></label>
                <span>{{ 'common.user.otp' | translate }}</span>
              </div>
              <button class="reSend-btn" nz-button [disabled]="resendDisabled" (click)="resend()">
                <ng-container *ngIf="!resendDisabled">
                  {{ 'common.user.reSend' | translate }}
                </ng-container>
                <ng-container *ngIf="resendDisabled">
                  {{ 'common.user.reSend' | translate }} ({{ resendCountdown }}s)
                </ng-container>
              </button>
            </div>
            <hbt-input-text
              class="login-input"
              [defaultInput]="true"
              placeholderText="{{ 'common.user.otp' | translate }}"
              formControlName="otpCode"
              [type]="isSubmitted && f['otpCode'].errors ? 'error' : 'default'"
              [showError]="isSubmitted && f['otpCode'].errors !== null"
              [errors]="f['otpCode'].errors"
              [errorDefs]="[{ errorName: 'required', errorDescription: 'common.validate.required' | translate: {'param': 'common.user.otpCode' | translate }}]">
            </hbt-input-text>
          </div>

          <!--password-->
          <div *ngIf="!isStep1" nz-col [nzXs]="24">
            <div class="input-title">
              <label><i class="fas fa-lock"></i></label>
              <span>{{ 'common.user.newPassword' | translate }}</span>
            </div>
            <hbt-input-text
              class="login-input"
              [defaultInput]="true"
              placeholderText="{{ 'common.user.newPassword' | translate }}"
              [inputType]="isFocus2 ? 'text':'password'"
              formControlName="newPassword"
              [type]="isSubmitted && f['newPassword'].errors ? 'error' : 'default'"
              [showError]="isSubmitted && f['newPassword'].errors !== null"
              [errors]="f['newPassword'].errors"
              [errorDefs]="[{ errorName: 'required', errorDescription: 'common.validate.required' | translate: {'param': 'common.user.password' | translate }}]">
            </hbt-input-text>
            <label class="pass-eye" (click)="onLabelClick2()">
              <span *ngIf="isFocus2" nz-icon nzType="eye" nzTheme="outline"></span>
              <span *ngIf="!isFocus2" nz-icon nzType="eye-invisible" nzTheme="outline"></span>
            </label>
          </div>
          <div div *ngIf="!isStep1" nz-col [nzXs]="24">
            <div class="password-rule-box">
              <div class="rule-item">
                <i class="fa"
                   [ngClass]="passwordRules.length ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'">
                </i>
                <span>≥ 8 ký tự</span>
              </div>
              <div class="rule-item">
                <i class="fa"
                   [ngClass]="passwordRules.complexity ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'">
                </i>
                <span>Chữ hoa, chữ thường, số</span>
              </div>
              <div class="rule-item">
                <i class="fa"
                   [ngClass]="passwordRules.special ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'">
                </i>
                <span>Ký tự đặc biệt</span>
              </div>
            </div>
          </div>

          <!--rePassword-->
          <div *ngIf="!isStep1" nz-col [nzXs]="24">
            <div class="input-title">
              <label><i class="fas fa-lock"></i></label>
              <span>{{ 'common.user.retypePassword' | translate }}</span>
            </div>
            <hbt-input-text
              class="login-input"
              [defaultInput]="true"
              placeholderText="{{ 'common.user.retypePassword' | translate }}"
              formControlName="retypePassword" [inputType]="isFocus3 ? 'text':'password'"
              [type]="isSubmitted && f['retypePassword'].errors ? 'error' : 'default'"
              [showError]="isSubmitted && f['retypePassword'].errors !== null"
              [errors]="f['retypePassword'].errors"
              [errorDefs]="[{ errorName: 'required', errorDescription: 'common.validate.required' | translate: {'param': 'common.user.retypePassword' | translate }}]">
            </hbt-input-text>
            <label class="pass-eye" (click)="onLabelClick3()">
              <span *ngIf="isFocus3" nz-icon nzType="eye" nzTheme="outline"></span>
              <span *ngIf="!isFocus3" nz-icon nzType="eye-invisible" nzTheme="outline"></span>
            </label>
          </div>

          <!--2FA: chỉ hiện khi BE báo tài khoản đã bật 2FA-->
          <div *ngIf="!isStep1 && show2fa" nz-col [nzXs]="24">
            <div class="input-title">
              <label><i class="fas fa-shield-alt"></i></label>
              <span>Mã 2FA</span>
            </div>
            <hbt-input-text
              class="login-input"
              [defaultInput]="true"
              placeholderText="Nhập mã 6 số từ Authenticator hoặc mã khôi phục"
              formControlName="totpCode">
            </hbt-input-text>
            <div style="margin-top: 8px; text-align: right">
              <a routerLink="/recovery-request" style="font-size: 12px; color: #ef4444;">
                Mất thiết bị và không nhớ mã khôi phục? Yêu cầu hỗ trợ
              </a>
            </div>
          </div>

        </div>
        <button *ngIf="!isStep1" class="password__btn" nz-button
                (click)="submitForm()">{{ 'common.user.changePassword2' | translate }}
        </button>
        <button *ngIf="isStep1" class="password__btn" nz-button
                (click)="continue()">{{ 'common.button.continue' | translate }}
        </button>
        <div style="width: 100%; justify-content: center; display: flex">
          <button class="back__btn" nz-button (click)="back()">
            <label><i class="fa fa-arrow-left"></i></label>
            {{ 'common.button.back3' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


<ng-template #contentTemplate>
  <div innerHTML="{{ 'common.user.content' | translate }}"></div>
</ng-template>
